import { render, staticRenderFns } from "./CityMapProduct.vue?vue&type=template&id=52d5294a&scoped=true&"
import script from "./CityMapProduct.vue?vue&type=script&lang=js&"
export * from "./CityMapProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d5294a",
  null
  
)

export default component.exports